import Repository from './Repository'
import TokenService from '../helpers/token'

const resource = `${Repository.defaults.shortLinkUrl}`

export default {
    async create(body) {
        const response = await Repository.post(`${resource}/create-short-link`, body, {
            headers: TokenService.getHeader(),
        })
        return response
    },
    async list(params) {
        const response = await Repository.get(`${resource}/short-link/list`, {
            params,
            headers: TokenService.getHeader(),
        })
        return response
    },
    async update(id, params) {
        const response = await Repository.patch(`${resource}/update-short-link/${id}`, params, {
          headers: TokenService.getHeader(),
        })
        return response
    },
    async updateUser(params) {
        const response = await Repository.put(`${resource}/assign`, params, {
          headers: TokenService.getHeader(),
        })
        return response
    },
    async listNPT(params,id) {
        const response = await Repository.get(`${resource}/user-orgs-lower/${id}`, {
            params,
            headers: TokenService.getHeader(),
        })
        return response
    },
    async getListDomain() {
        const response = await Repository.get(`${resource}/short-link/list-domain`, {
            headers: TokenService.getHeader(),
        })
        return response
    }
}